import { useId } from 'react';

export default function SyncLoadingIllustration() {
  const clipId = useId();

  return (
    <div className="flex size-32 items-center justify-center">
      <svg
        width="124"
        height="116"
        viewBox="0 0 124 116"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="同期中"
      >
        <defs>
          {/* ノートPC上端より上だけを描画し、図形が画面に吸い込まれて消えるように見せる */}
          <clipPath id={clipId}>
            <rect x="-10" y="-30" width="150" height="76.14" />
          </clipPath>
        </defs>

        <g clipPath={`url(#${clipId})`}>
          <g className="animate-rise-fall motion-reduce:animate-none">
            <path
              d="M48.6832 72.1909L46.8327 73.0485L45.6762 70.6232L47.5266 69.7656L48.6832 72.1909ZM46.3701 67.3402L44.5264 68.1978L43.3699 65.7724L45.2135 64.9148L46.3701 67.3402ZM44.057 62.4828L42.2065 63.3404L41.05 60.915L42.9005 60.0574L44.057 62.4828ZM41.7439 57.632L39.9002 58.4896L38.7437 56.0643L40.5874 55.2067L41.7439 57.632ZM39.4308 52.7813L37.5803 53.6389L36.4238 51.2135L38.2743 50.3559L39.4308 52.7813ZM37.1109 47.9306L35.2673 48.7882L34.1107 46.3628L35.9612 45.5052L37.1177 47.9306H37.1109ZM34.7978 43.0798L32.9474 43.9374L31.7908 41.5121L33.6413 40.6545L34.7978 43.0798ZM32.4848 38.2291L30.6343 39.0867L29.4777 36.6613L31.3282 35.8038L32.4848 38.2291ZM30.1717 33.3784L28.3212 34.236L27.1647 31.8106L29.0151 30.953L30.1717 33.3784ZM27.8586 28.5277L26.0081 29.3852L24.8516 26.9599L26.702 26.1023L27.8586 28.5277Z"
              fill="#83D2FF"
            />
            <path
              d="M14.1664 1.54785L7.25 30.7611L36.5558 22.0162L14.1664 1.54785Z"
              fill="#0D429B"
            />
          </g>

          <g className="animate-rise-fall [animation-delay:0.22s] motion-reduce:animate-none">
            <path
              d="M63.0722 71.005L61.0312 70.9581L61.0993 68.2782L63.1402 68.3251L63.0722 71.005ZM63.2083 65.6451L61.1673 65.5982L61.2353 62.9182L63.2763 62.9651L63.2083 65.6451ZM63.3443 60.2919L61.3034 60.245L61.3714 57.565L63.4124 57.6119L63.3443 60.2919ZM63.4736 54.9319L61.4326 54.885L61.5007 52.2051L63.5416 52.252L63.4736 54.9319ZM63.6097 49.572L61.5687 49.5251L61.6367 46.8452L63.6777 46.8921L63.6097 49.572ZM63.7457 44.2121L61.7048 44.1652L61.7728 41.4852L63.8138 41.5321L63.7457 44.2121ZM63.8818 38.8589L61.8408 38.812L61.9089 36.132L63.9498 36.1789L63.8818 38.8589ZM64.011 33.499L61.9701 33.4521L62.0381 30.7721L64.0791 30.819L64.011 33.499ZM64.1471 28.139L62.1062 28.0921L62.1742 25.4122L64.2151 25.4591L64.1471 28.139ZM64.2832 22.7791L62.2422 22.7322L62.3102 20.0522L64.3512 20.0991L64.2832 22.7791Z"
              fill="#83D2FF"
            />
            <path
              d="M63.548 0.010498L50.4375 9.40749L55.4458 24.6111H71.6502L76.6585 9.40749L63.548 0.010498Z"
              fill="#005FFF"
            />
          </g>

          <g className="animate-rise-fall [animation-delay:0.44s] motion-reduce:animate-none">
            <path
              d="M73.4767 71.6883L71.6875 70.7169L73.0005 68.3719L74.7898 69.3434L73.4767 71.6883ZM76.096 66.9917L74.3067 66.0202L75.6198 63.6753L77.409 64.6467L76.096 66.9917ZM78.722 62.2951L76.9328 61.3236L78.2458 58.9786L80.035 59.9501L78.722 62.2951ZM81.348 57.5984L79.5588 56.6269L80.8718 54.282L82.6611 55.2535L81.348 57.5984ZM83.9741 52.9018L82.1848 51.9303L83.4979 49.5853L85.2871 50.5568L83.9741 52.9018ZM86.6001 48.2052L84.8109 47.2337L86.1239 44.8887L87.9131 45.8602L86.6001 48.2052ZM89.2262 43.5152L87.4369 42.5438L88.7499 40.1988L90.5392 41.1703L89.2262 43.5152ZM91.8454 38.8186L90.0561 37.8471L91.3692 35.5022L93.1584 36.4736L91.8454 38.8186ZM94.4714 34.122L92.6822 33.1505L93.9952 30.8055L95.7844 31.777L94.4714 34.122ZM97.0975 29.4253L95.3082 28.4539L96.6212 26.1089L98.4105 27.0804L97.0975 29.4253Z"
              fill="#83D2FF"
            />
            <path
              d="M102.875 27.6859C108.838 27.6859 113.672 22.8673 113.672 16.9232C113.672 10.9791 108.838 6.1604 102.875 6.1604C96.9121 6.1604 92.0781 10.9791 92.0781 16.9232C92.0781 22.8673 96.9121 27.6859 102.875 27.6859Z"
              fill="#48B7FF"
            />
          </g>
        </g>

        <path
          d="M108.46 106.869C108.46 108.589 107.051 109.977 105.305 109.977H13.4916C11.7456 109.977 10.3359 108.589 10.3359 106.869V49.2442C10.3359 47.5247 11.7456 46.1365 13.4916 46.1365H105.305C107.051 46.1365 108.46 47.5247 108.46 49.2442"
          fill="#0D429B"
        />
        <path
          d="M103.952 51.7739V103.787C103.952 104.577 103.3 105.218 102.506 105.218H16.2885C15.4871 105.218 14.8359 104.577 14.8359 103.787V51.7739C14.8359 50.7944 15.6374 50.0051 16.632 50.0051H102.148C103.143 50.0051 103.944 50.7944 103.944 51.7739H103.952Z"
          fill="white"
        />
        <g opacity="0.3">
          <path
            d="M51.0156 63.5C51.0156 62.6716 51.6872 62 52.5156 62H93.5156C94.3441 62 95.0156 62.6716 95.0156 63.5V63.5C95.0156 64.3284 94.3441 65 93.5156 65H52.5156C51.6872 65 51.0156 64.3284 51.0156 63.5V63.5Z"
            fill="#48B7FF"
          />
          <path
            d="M51.0156 69.3333C51.0156 68.5048 51.6872 67.8333 52.5156 67.8333H93.5156C94.3441 67.8333 95.0156 68.5048 95.0156 69.3333V69.3333C95.0156 70.1617 94.3441 70.8333 93.5156 70.8333H52.5156C51.6872 70.8333 51.0156 70.1617 51.0156 69.3333V69.3333Z"
            fill="#48B7FF"
          />
          <path
            d="M51.0156 75.1667C51.0156 74.3383 51.6872 73.6667 52.5156 73.6667H93.5156C94.3441 73.6667 95.0156 74.3383 95.0156 75.1667V75.1667C95.0156 75.9952 94.3441 76.6667 93.5156 76.6667H52.5156C51.6872 76.6667 51.0156 75.9952 51.0156 75.1667V75.1667Z"
            fill="#48B7FF"
          />
          <path
            d="M51.0156 81C51.0156 80.1716 51.6872 79.5 52.5156 79.5H93.5156C94.3441 79.5 95.0156 80.1716 95.0156 81V81C95.0156 81.8284 94.3441 82.5 93.5156 82.5H52.5156C51.6872 82.5 51.0156 81.8284 51.0156 81V81Z"
            fill="#48B7FF"
          />
          <path
            d="M51.0156 86.8333C51.0156 86.0048 51.6872 85.3333 52.5156 85.3333H93.5156C94.3441 85.3333 95.0156 86.0048 95.0156 86.8333V86.8333C95.0156 87.6617 94.3441 88.3333 93.5156 88.3333H52.5156C51.6872 88.3333 51.0156 87.6617 51.0156 86.8333V86.8333Z"
            fill="#48B7FF"
          />
          <path
            d="M51.0156 92.6667C51.0156 91.8383 51.6872 91.1667 52.5156 91.1667H93.5156C94.3441 91.1667 95.0156 91.8383 95.0156 92.6667V92.6667C95.0156 93.4952 94.3441 94.1667 93.5156 94.1667H52.5156C51.6872 94.1667 51.0156 93.4952 51.0156 92.6667V92.6667Z"
            fill="#48B7FF"
          />
          <path
            d="M51.0156 98.5C51.0156 97.6716 51.6872 97 52.5156 97H93.5156C94.3441 97 95.0156 97.6716 95.0156 98.5V98.5C95.0156 99.3284 94.3441 100 93.5156 100H52.5156C51.6872 100 51.0156 99.3284 51.0156 98.5V98.5Z"
            fill="#48B7FF"
          />
        </g>
        <g opacity="0.3">
          <path
            d="M103.952 51.7739V55.4947H14.8438V51.7739C14.8438 50.7944 15.6452 50.0051 16.6398 50.0051H102.156C103.151 50.0051 103.952 50.7944 103.952 51.7739Z"
            fill="#48B7FF"
          />
        </g>
        <path
          d="M93.626 52.7459C93.626 53.4363 93.0609 53.9929 92.3599 53.9929C91.6589 53.9929 91.0938 53.4363 91.0938 52.7459C91.0938 52.0556 91.6589 51.499 92.3599 51.499C93.0609 51.499 93.626 52.0556 93.626 52.7459Z"
          fill="#005FFF"
        />
        <path
          d="M96.4693 53.9929C97.1685 53.9929 97.7354 53.4346 97.7354 52.7459C97.7354 52.0573 97.1685 51.499 96.4693 51.499C95.77 51.499 95.2031 52.0573 95.2031 52.7459C95.2031 53.4346 95.77 53.9929 96.4693 53.9929Z"
          fill="#0D429B"
        />
        <path
          d="M100.391 53.9929C101.09 53.9929 101.657 53.4346 101.657 52.7459C101.657 52.0573 101.09 51.499 100.391 51.499C99.6919 51.499 99.125 52.0573 99.125 52.7459C99.125 53.4346 99.6919 53.9929 100.391 53.9929Z"
          fill="#0D429B"
        />
        <rect x="21.1328" y="61.512" width="23.1361" height="23.0631" fill="#48B7FF" />
        <path
          d="M32.7046 74.4701C31.3412 74.4701 30.2084 74.0115 29.3063 73.0943C28.4044 72.1768 27.9535 71.0249 27.9535 69.6384C27.9535 68.2518 28.4044 67.0999 29.3063 66.1824C30.2084 65.2652 31.3412 64.8066 32.7046 64.8066C34.0679 64.8066 35.2007 65.2652 36.1028 66.1824C37.0047 67.0999 37.4556 68.2518 37.4556 69.6384C37.4556 71.0249 37.0047 72.1768 36.1028 73.0943C35.2007 74.0115 34.0679 74.4701 32.7046 74.4701ZM22.7891 84.575V81.4238C22.7891 80.6534 22.9801 79.9794 23.3623 79.4017C23.7445 78.824 24.242 78.3846 24.8549 78.0835C26.2044 77.4464 27.523 76.9684 28.8106 76.6497C30.0983 76.3311 31.3963 76.1717 32.7046 76.1717C34.0128 76.1717 35.3073 76.3345 36.588 76.6601C37.8688 76.9858 39.184 77.4602 40.5338 78.0835C41.1603 78.3846 41.6646 78.824 42.0468 79.4017C42.429 79.9794 42.62 80.6534 42.62 81.4238V84.575H22.7891Z"
          fill="#0D429B"
        />
        <path
          d="M0.245567 111.92L122.64 111.92C122.774 111.92 122.883 111.812 122.883 111.678V106.909C122.883 106.775 122.774 106.667 122.64 106.667L0.245567 106.667C0.111496 106.667 0.00281525 106.775 0.00281525 106.909V111.678C0.00281525 111.812 0.111496 111.92 0.245567 111.92Z"
          fill="#0D429B"
        />
      </svg>
    </div>
  );
}
